<template>
  <section
    :class="[$style.login, $style.fullscreen]"
    :style="{
      backgroundImage: 'url(\'resources/images/fondo-aol.jpg\')'
    }"
  >
    <header :class="$style.header">
      <a href="javascript: void(0);" :class="$style.logo">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
        />
      </a>
      <!--
      <div :class="$style.styleControls">
        <a-button class="mt-3 mt-xl-0" @click="setFullscreen"
          >Set {{ fullscreen ? "Windowed" : "Fullscreen" }}</a-button
        >
        <a-button class="ml-3 mt-3 mt-xl-0" @click="changeBackground"
          >Change Background</a-button
        >
      </div>
      -->
      <nav :class="$style.loginNav">
        <ul :class="$style.navItems">
          <li>
            <a-button type="link" @click="goBack()">&larr; Volver</a-button>
          </li>
          <!--
          <li>
            <a :class="$style.active" href="javascript: void(0);">Login</a>
          </li>
          <li>
            <a href="javascript: void(0);">About</a>
          </li>
          <li>
            <a href="javascript: void(0);">Support</a>
          </li>
          -->
        </ul>
      </nav>
    </header>
    <div :class="$style.content">
      <div :class="$style.promo">
        <h1 class="mb-3 text-white">Ingresa los datos de pago</h1>
        <p>
          Para completar la suscripción ingresa los datos de tu tarjeta de
          débito o crédito.
        </p>
      </div>

      <div :class="$style.formWrapper">
        <div :class="$style.form" v-if="subscriptionError">
          <p :class="$style.formTitle">
            Hubo un error al cargar la subscripción. <br /><span
              style="font-size:12px"
              >Por favor, volver atrás y volver a intentar.</span
            >
          </p>
          <div class="login-form">
            <a-button type="primary" @click="goBack()"
              ><a-icon type="left" /> Volver
            </a-button>
          </div>
        </div>
        <div :class="$style.form" v-else>
          <p :class="$style.formSubtitle" style="margin-left:0.5rem;">
            DATOS DE PAGO
          </p>

          <payment-form
            v-if="subscription"
            ref="paymentFormComponent"
            :mode="'2-step'"
            :showPrice="true"
            :showInstallments="false"
            :publicKey="subscription.account.publicKey"
          />
          <vue-recaptcha
            sitekey="6Lf47sUUAAAAAHzkc0paHmaLsN2kUA_5pv2ZIDwi"
            :loadRecaptchaScript="true"
            @verify="handleRecaptchaVerified"
            style="margin-top: 1rem"
          >
          </vue-recaptcha>

          <div class="form-actions">
            <a-button
              @click="
                submitLoader = true;
                handleSubmit();
              "
              type="primary"
              html-type="submit"
              :class="$style.loginFormButton"
              :loading="submitLoader"
              size="large"
              icon="lock"
            >
              SUSCRIBIRME
            </a-button>
          </div>
        </div>
        <div :class="$style.sidebar">
          <p :class="$style.sidebarTitle">
            {{ subscription.name }}
          </p>

          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <strong>Precio:</strong>
            ${{ subscription.amount }}
            <span v-if="subscription.account.gatewayId == 1"> ARS </span>
            <span v-else-if="subscription.account.gatewayId == 2"> USD </span> /
            <span v-if="subscription.frequencyId == 1">mes</span>
            <span v-if="subscription.frequencyId == 2">año</span>
            <br />
            <span v-if="subscription.freeTrialDays" style="font-weight:bold"
              >{{ subscription.freeTrialDays }} días de prueba sin cargo</span
            >
          </p>
          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <i class="icmn-user mr-3" /> Usuario: <br />
            {{ email }}
            <span v-if="phone"
              ><br />
              Tel: {{ phone }}
            </span>
          </p>
          <div :class="$style.sidebarFooter" style="margin-bottom:1rem">
            <span>
              <i class="icmn-location mr-3" />
              {{ sellerUserId }}
            </span>
          </div>
          <div :class="$style.sidebarContent">
            <p>
              <strong>Términos y Condiciones:</strong><br />
              <span v-if="subscription.account.gatewayId == 1">
                Los datos ingresados son procesados directamente por el gateway
                de pagos Decidir Prisma<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
              <span v-else>
                Los datos ingresados son procesados directamente por la pasarela
                de pagos Páguelo Fácil<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>

              <!--
              Visa, MasterCard, American Express, ArgenCard, BBPS, Cabal, Cabal
              Prisma, CoopePlus, CrediGuia, Credimás, Diners Club, Distribution,
              Favacard, Grupar, Italcred, MasterCard Prisma, Nativa, Nexo,
              Patagonia 365, Qida, Tarjeta Carrefour / Cetelem, Tarjeta
              Cencosud, Tarjeta Club Día, Tarjeta La Anónima, Tarjeta Naranja,
              Tarjeta Nevada, Tarjeta PymeNacion, Tarjeta Shopping, Tarjeta SOL,
              Tuya-->
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer :class="$style.footer" style="text-align:center; margin-top:5rem">
      <span style="color:#ccc;">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
          width="120"
        /><br />
        <!-- Darregueyra 2390, Palermo Buenos Aires, Argentina.<br /> -->
        <a href="https://elartedevivir.org" target="_blank">elartedevivir.org</a
        ><br />
        Darregueyra 2390, Ciudad Autónoma de Buenos Aires, Argentina.
      </span>
      <!--<ul :class="$style.footerNav">
        <li>
          <a href="javascript: void(0);">Términos y Condiciones</a>
        </li>
        <li>
          <a href="javascript: void(0);">Compliance</a>
        </li>
        <li>
          <a href="javascript: void(0);">Confidencialidad</a>
        </li>
        <li>
          <a href="javascript: void(0);">Soporte</a>
        </li>
        <li>
          <a href="javascript: void(0);">Contacto</a>
        </li>
      </ul>-->
    </footer>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
import VueRecaptcha from "vue-recaptcha";
import utils from "@/services/utils";
import PaymentForm from "@/components/PaymentForm";

export default {
  data: function() {
    return {
      subscriptionId: this.$route.query.subscriptionId,
      userId: this.$route.query.userId,
      email: this.$route.query.email,
      phone: this.$route.query.tel || null,
      sellerUserId: this.$route.query.sellerUserId,
      form: this.$form.createForm(this),
      loading: false,
      subscription: {},
      submitLoader: false,
      subscriptionError: false,
      recaptchaKey: null,
      cardPattern: new RegExp(".{1,4}", "g"),
      cardKey: null,
      expDateKey: null,
      CVCKey: null
      //fullscreen: false,
      //backgroundNumber: 1
    };
  },
  components: { PaymentForm, VueRecaptcha },
  methods: {
    ...mapActions({
      loadSubscription: "membresiaForm/load",
      subscribe: "membresiaForm/subscribe"
    }),
    handleRecaptchaVerified(key) {
      this.recaptchaKey = key;
    },
    formatCardNumber(e) {
      return utils.formatCardNumber(e, this.cardKey);
    },
    validateCardNumber(rule, val, callback) {
      utils.validateCardNumber(rule, val, callback);
    },
    formatExpDate(e) {
      return utils.formatExpDate(e, this.expDateKey);
    },
    formatCVC(e) {
      return utils.formatCVC(e, this.CVCKey);
    },
    /*changeBackground() {
      if (this.backgroundNumber === 5) {
        this.backgroundNumber = 1;
      } else {
        this.backgroundNumber += 1;
      }
    },
    setFullscreen() {
      this.fullscreen = !this.fullscreen;
    }*/
    async handleSubmit(e) {
      //e.preventDefault();
      this.submitLoader = true; //local loader button
      this.$refs.paymentFormComponent.enableSubmitLoader();

      const paymentFormPayload = await this.$refs.paymentFormComponent.handleSubmit();

      if (paymentFormPayload) {
        if (!this.recaptchaKey) {
          this.$notification["warning"]({
            message: "Error",
            description: "Por favor, hacer click en el botton de Recaptcha."
          });
        } else {
          try {
            const res = await this.subscribe({
              paymentFormPayload,
              email: this.email,
              phone: this.phone,
              sellerUserId: this.sellerUserId,
              recaptcha: this.recaptchaKey
            });
            this.submitLoader = false;
            this.$notification["success"]({
              message: "La suscripción fue procesada con éxito."
            });
            this.submitLoader = false;
            window.location.href = `https://membresia.org/`;
          } catch (err) {
            let description;
            if (err.message) description = err.message;
            else
              description =
                "Error al procesar el pago. Por favor, intente denuevo.";
            this.submitLoader = false;
            this.$notification["warning"]({
              message: "Error",
              description: description
            });
          }
        }
      }
      this.submitLoader = false;
    },
    goBack() {
      window.history.back();
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  async created() {
    try {
      const res = await this.loadSubscription(this.$route.query.subscriptionId);
      this.subscription = store.state.membresiaForm.subscription;
      store.state.paymentForm.subtotal = this.subscription.amount;
    } catch (error) {
      this.subscriptionError = true;
      this.$notification["warning"]({
        message: "Error",
        description: error.message
      });
    }
  },
  mounted() {
    this.$refs.initial.$el.children[1].focus(); //focus 1st input on page load.
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style>
.ant-input {
  height: inherit !important;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
</style>
